import React, { useEffect, useState } from 'react';
import { LottieAnimation } from '../lottie-animation';

type Props = {
  width?: number;
} & React.InputHTMLAttributes<HTMLInputElement>;

export function ConfettiAnimation({ width }: Props): JSX.Element {
  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    import('./confetti.json')
      .then((data) => {
        setAnimationData(data.default);
      })
      .catch((error) => console.error('Error loading animation data:', error));
  }, []);

  return (
    <LottieAnimation
      animationData={animationData}
      width={width}
      loop
      autoplay
    />
  );
}
